module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header.15207bbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/BattleRoomsWrapper/images/header.jpg
// module id = 2737
// module chunks = 11